export function initTerugbetalenPage() {
    loadPartialContents();
    initRedemptionsPagination();
    
    const cesKey = document.querySelector("[data-ces-key]")?.dataset?.cesKey;
    window.customerEffortScore.trigger(cesKey);
}

// Client-side pagination: all rows are rendered server-side, JS shows one page
// at a time. No server round-trip, so #fineFreeTexts is never reloaded.
function initRedemptionsPagination() {
    const container = document.querySelector("#redemptions-overview");
    if (!container) return;

    const rows = Array.from(container.querySelectorAll("tbody tr"));
    if (!rows.length) return;

    const pagination = container.querySelector("nav.table-pagination");
    if (!pagination) return;

    const pageSize = parseInt(pagination.dataset.paginationPageSize, 10);
    const totalPages = parseInt(pagination.dataset.paginationTotalPages, 10);
    let currentPage = parseInt(pagination.dataset.paginationCurrentPage, 10);

    const metaPrevPage = container.querySelector(".table-pagination-meta .prev");
    const prevLink = container.querySelector(".table-pagination a[rel='prev']");
    const nextLink = container.querySelector(".table-pagination a[rel='next']");

    function showPage(page) {
        currentPage = page;

        rows.forEach((row, index) => {
            row.hidden = Math.floor(index / pageSize) + 1 !== page;
        });

        if (metaPrevPage) metaPrevPage.textContent = `${page}`;
        if (prevLink) prevLink.hidden = page <= 1;
        if (nextLink) nextLink.hidden = page >= totalPages;
    }

    function handlePaginationClick(event) {
        const link = event.target.closest(".table-pagination a[rel]");
        if (!link) return;

        event.preventDefault();
        showPage(link.rel === "prev" ? currentPage - 1 : currentPage + 1);
    };

    container.addEventListener("click", handlePaginationClick);

    showPage(currentPage);
}

function loadPartialContents() {
    const el = document.querySelector("#fineFreeTexts");
    const url = el?.dataset.url;
    if (url) {
        fetch(url, { credentials: "same-origin" })
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
                console.error(`[partialContents] Failed to load ${url}: ${response.status}`);
                return "";
            })
            .then(html => {
                el.innerHTML = html;
            })
            .catch(err => {
                console.error(`[partialContents] Error loading ${url}:`, err);
                el.innerHTML = "";
            });
    }
}